import React, { useState } from "react";
import { UploadOutlined } from "@ant-design/icons";
import { Alert, Avatar, Button, Col, Divider, Row, Upload } from "antd";
import TextArea from "antd/es/input/TextArea";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

const SingleMoveOut = ({ itemId, listId, checkedItems }) => {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);
  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {

    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div>
      <h3 style={{ color: "#e15951" }}>
        If only one tenant is moving out we will not refund the Security Deposit
        until all tenants have vacated
      </h3>

      <Alert
        message="Send this email to the tenant through appfolio"
        type="success"
        style={{ marginTop: "10px", marginBottom: "10px" }}
      />

      <Alert
        message="We show only one occupant of your residence is vacating.  We are processing their move out on our system.  A few items for you to be aware of.
        - all remaining occupants will be responsible for all terms of the lease including the full rent.
        - the security deposit is only refunded when all occupants move out.
        If the vacating occupant would like their deposit they will need to work out an agreement to be 'paid out' by the occupants that remain.
        "
        type="success"
        style={{ marginTop: "10px", marginBottom: "10px" }}
      />

      <Alert
        message="Let us know if you have any questions along the way."
        type="success"
        style={{ marginTop: "10px", marginBottom: "10px" }}
      />

      <Alert
        message="Click finish move out on the single tenants page in appfolio"
        type="info"
        style={{ marginTop: "10px", marginBottom: "10px" }}
      />

      <Row justify="end" gutter={16}>
        <Col>
          <Button>Skip</Button>
        </Col>
        <Col>
          <Button
            type="primary"
            htmlType="submit"
            onClick={handleComplete}
            disabled={isDisabled}
          >
            Complete
          </Button>
        </Col>
      </Row>

      <Divider />

      <Row>
        <Col span={2}>
          <Avatar>KA</Avatar>
        </Col>
        <Col span={22}>
          <TextArea
            style={{
              height: 200,
              resize: "none",
            }}
            placeholder="Write a comment… Type @ to mention other users."
          />
        </Col>
      </Row>
      <Row justify="end" gutter={16}>
        <Col>
          <Upload>
            <Button style={{ marginTop: "10px" }}>
              <UploadOutlined />
            </Button>
          </Upload>
        </Col>
        <Col>
          <Button style={{ marginTop: "10px" }}>Send</Button>
        </Col>{" "}
      </Row>
    </div>
  );
};

export default SingleMoveOut;
